import { TimeseriesChart } from '../charts/TimeseriesChart.tsx';
import { TopNChart } from '../charts/TopNChart.tsx';
import { Panel, ReportHeader } from '../components/Panel.tsx';

export function WgTrendReportPage() {
  return (
    <div className="space-y-6 w-full max-w-[1400px] mx-auto">
      <ReportHeader
        title="Warengruppen-Trend"
        desc="Umsatz einer Warengruppe über die Zeit mit Vorjahresvergleich. Wähle links im Filter eine (oder mehrere) Warengruppe — der Verlauf passt sich an."
      />
      <Panel title="Umsatz im Zeitverlauf" subtitle="Gefiltert auf die gewählte(n) Warengruppe(n) · Vorjahresvergleich">
        <TimeseriesChart />
      </Panel>
      <Panel title="Warengruppen-Ranking" subtitle="Nach Umsatz — Klick filtert den Verlauf oben">
        <TopNChart dimension="warengruppe_name" measure="umsatz" limit={15} />
      </Panel>
    </div>
  );
}
